module.exports = __webpack_public_path__ + "img/bottom_banner.2c4e0050.png";